import { render } from "./module.vue?vue&type=template&id=da3d223c"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/projects-gallery-slider/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "da3d223c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('da3d223c', __exports__)) {
    api.reload('da3d223c', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=da3d223c", () => {
    api.rerender('da3d223c', render)
  })

}


export default __exports__